import React from 'react';

const FeatureRequestAttachmentViewer = ({ url, onClose }) => {
  if (!url) return null;

  const isPdf = /\.pdf(?:$|[?#])/i.test(url);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 5000,
        backgroundColor: 'rgba(0,0,0,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        onClick={(event) => event.stopPropagation()}
        style={{
          backgroundColor: 'white',
          padding: '1rem',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          width: isPdf ? '90vw' : 'auto',
          height: isPdf ? '90vh' : 'auto',
          maxWidth: '90vw',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h3 style={{ margin: 0 }}>Attachment</h3>
          <button type="button" onClick={onClose} aria-label="Close attachment preview" style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer', fontSize: '20px', padding: '0.25rem' }}>✕</button>
        </div>
        <div style={{ flex: 1, overflow: 'auto', textAlign: 'center', minWidth: 0, minHeight: 0 }}>
          {isPdf ? (
            <iframe src={url} title="Feature request attachment" style={{ width: '100%', height: '75vh', border: 'none' }} />
          ) : (
            <img src={url} alt="Feature request attachment" style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} />
          )}
          </div>
      </div>
    </div>
  );
};

export default FeatureRequestAttachmentViewer;
